import { get } from 'api/get';
import _ from 'lodash';

import { buildErrorPayload } from 'state/buildErrorPayload';
import { appendStatus } from 'state/status/actions';

export const VENDORS_GET_DASHBOARD_DATA_REQUEST = 'vendors/get-dashboard/request';
export const VENDORS_GET_DASHBOARD_DATA_SUCCESS = 'vendors/get-dashboard/success';
export const VENDORS_GET_DASHBOARD_DATA_FAILURE = 'vendors/get-dashboard/failure';


export function getDashboardData() {
  return async (dispatch) => {

    dispatch({
      type: VENDORS_GET_DASHBOARD_DATA_REQUEST,
      payload: null
    });

    try {
      const req = await get('vendors/dashboard-data');
      const data = _.get(req, 'data.payload', []);

      dispatch({
        type: VENDORS_GET_DASHBOARD_DATA_SUCCESS,
        payload: data
      });
    }
    catch (error) {
      const errPayload = buildErrorPayload(error);

      dispatch({
        type: VENDORS_GET_DASHBOARD_DATA_FAILURE,
        payload: errPayload
      });

      dispatch(appendStatus(errPayload.errorMessage, 'error'));
    }
  }
}
